/** Base URL of the Nest API (no trailing slash). */
export const API_BASE_URL = (
	process.env.REACT_APP_API_URL ?? 'http://localhost:3001'
).replace(/\/$/, '');

export function apiUrl(path: string): string {
	const p = path.startsWith('/') ? path : `/${path}`;
	return `${API_BASE_URL}${p}`;
}
